import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import { formatCurrency, formatDate } from '../lib/formatters';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-[hsl(var(--border))] rounded-lg p-3 shadow-lg">
        <p className="text-sm font-semibold text-[hsl(var(--text-primary))]">
          {formatCurrency(payload[0].value)}
        </p>
        <p className="text-xs text-[hsl(var(--text-secondary))]">
          {formatDate(payload[0].payload.timestamp)}
        </p>
      </div>
    );
  }
  return null;
};

export const PriceChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white border border-[hsl(var(--border))] rounded-xl p-6">
        <h3 className="text-lg font-semibold text-[hsl(var(--text-primary))] mb-4">
          Price History
        </h3>
        <div className="h-64 flex items-center justify-center text-[hsl(var(--text-secondary))]">
          No price history available
        </div>
      </div>
    );
  }

  return (
    <div data-testid="price-chart-container" className="bg-white border border-[hsl(var(--border))] rounded-xl p-6">
      <h3 className="text-lg font-semibold text-[hsl(var(--text-primary))] mb-4">
        Price History
      </h3>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="hsl(220, 85%, 52%)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="hsl(220, 85%, 52%)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(220, 15%, 88%)" />
            <XAxis
              dataKey="timestamp"
              tickFormatter={(value) => formatDate(value)}
              stroke="hsl(220, 10%, 45%)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              tickFormatter={(value) => formatCurrency(value)}
              stroke="hsl(220, 10%, 45%)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="price"
              stroke="hsl(220, 85%, 52%)"
              strokeWidth={2}
              fill="url(#colorPrice)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};